import React from 'react';
import { useSelector } from 'react-redux';
import { getRTL } from '@yme/selectors/common';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { getActiveItem } from '../helpers';
import { getDealerLocatorSearchedPlace } from '../redux/selectors';
import { MAX_COUNT_VISIBLE_ITEMS } from './constants';
import { DropDownListHolderStyled, DropDownListStyled, ItemOptionStyled, RegularTextLevel4Styled, } from './styled';
export function DropDownResults(props) {
    const { suggestionList = [], searchedValue, isExpandedDropDown, rangeOfMaxVisibleItems = MAX_COUNT_VISIBLE_ITEMS, currIndex = 0, handleSelect, handleEnter, selectedValueByKeyboard, } = props;
    const searchedPlace = useSelector(getDealerLocatorSearchedPlace);
    const isRightToLeft = useSelector(getRTL);
    const isDropDownWithScroll = suggestionList?.length >= rangeOfMaxVisibleItems;
    if (suggestionList.length === 0) {
        return null;
    }
    return (React.createElement(DropDownListHolderStyled, { isExpandedDropDown: isExpandedDropDown, isRightToLeft: isRightToLeft },
        React.createElement(DropDownListStyled, { withScroll: isDropDownWithScroll, isRightToLeft: isRightToLeft }, suggestionList?.map((suggestionItem, index) => {
            const { place_id: placeId, description, structured_formatting: { main_text: mainText, secondary_text: secondaryText }, } = suggestionItem;
            const isActiveEntity = getActiveItem({
                suggestionValue: description,
                searchedValue: searchedPlace.value || '',
            });
            const isHovered = selectedValueByKeyboard !== null &&
                selectedValueByKeyboard >= 0 &&
                selectedValueByKeyboard === index;
            return (React.createElement(ItemOptionStyled, { key: placeId, tabIndex: 0, isHovered: isHovered, value: searchedValue.description, isActiveEntity: isActiveEntity, onClick: handleSelect(suggestionItem), onMouseEnter: handleEnter(index), role: "listitem", "aria-selected": index === currIndex },
                React.createElement(RegularTextLevel4, { as: "p" },
                    React.createElement(RegularTextLevel4Styled, { weight: 500 }, mainText),
                    secondaryText)));
        }))));
}
DropDownResults.displayName = 'GoogleLocationSearch_DropDownResults';
